<template>
  <div class="cart-button">
    <div class="cart">
      <div class="price">
        <div class="old-price" v-if="hasDiscount">
          <TweenPrice :price="vatPrice(totalPriceInMinorUnits / 100)" />
        </div>
        <div class="excl">
          <TweenPrice
            :price="vatPrice(totalDiscountedPriceInMinorUnits / 100)"
          />
        </div>
        <div class="incl">
          <template v-if="$store.state.data.includingVat">
            <TweenPrice :price="totalPriceInclBtw" />
            <span class="incl"> excl. BTW</span>
          </template>
          <template v-else>
            <TweenPrice :price="totalPriceExclBtw" />
            <span class="incl"> incl. BTW</span>
          </template>
        </div>
      </div>
      <div
        class="emat-btn button btn-add-to-cart add-to-cart-action"
        @click="cart"
      >
        <span v-if="pending">
          {{ $t('AddToCartSection.placing') }}
        </span>
        <span v-else>
          {{ $t('global.word.in_cart') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import TweenPrice from '../utilities/TweenPrice';

export default {
  name: 'AddToCartSection',
  components: { TweenPrice },

  props: {
    totalDiscountedPriceInMinorUnits: {
      type: Number,
      default: 0,
    },
    totalPriceInMinorUnits: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      guid: undefined,
      add_cart_url: undefined,
    };
  },

  computed: {
    ...mapGetters({
      pending: 'getPending',
      calculateTotalPriceWithDiscount:
        'discount/calculateTotalPriceWithDiscount',
    }),
    hasDiscount() {
      return (
        this.totalDiscountedPriceInMinorUnits !== this.totalPriceInMinorUnits
      );
    },
    totalPriceExclBtw() {
      return (this.totalDiscountedPriceInMinorUnits * 1.21) / 100;
    },
    totalPriceInclBtw() {
      return this.totalDiscountedPriceInMinorUnits / 100;
    },
  },

  methods: {
    ...mapMutations('popup', ['openPopup']),
    ...mapMutations('step', ['setStep']),

    cart() {
      if (this.pending) return;

      this.openPopup({
        type: 'order',
        metaData: {},
      });
    },

    goTo(targetStep) {
      this.setStep(targetStep);
    },
  },
};
</script>

<style scoped>
.old-price {
  text-decoration: line-through;
  font-size: 18px !important;
}

.btn-add-to-cart {
  align-self: center;
}
</style>
